import $ from 'jquery';

$.fn.syncInput = function (target) {
    'use strict';

    this.each(function (index, sourceNode) {
        var $source = $(sourceNode);

        target.each(function (index, targetNode) {
            var $target = $(targetNode);

            $target.on('change', function () {
                $source.val($target.val());
            });

            $source.on('change', function () {
                $target.val($source.val());
            });
        });
    });
};